import { useState } from "react"

import { Combobox, type ComboboxOption } from "@/components/ui/combobox"

const OPTIONS: ComboboxOption[] = [
  { value: "acme", label: "Acme Chemicals", description: "Client · 12 engagements" },
  { value: "bayer", label: "Bayer AG", description: "Client · 4 engagements" },
  { value: "corteva", label: "Corteva Agriscience", description: "Client · 7 engagements" },
  { value: "dow", label: "Dow Inc.", description: "Client · 3 engagements" },
  { value: "fmc", label: "FMC Corporation", description: "Client · 2 engagements" },
  { value: "syngenta", label: "Syngenta", description: "Client · 8 engagements" },
  { value: "upl", label: "UPL Limited", description: "Client · 1 engagement" },
]

export function ComboboxPreviewRoute(): JSX.Element {
  const [value, setValue] = useState<string | null>(null)

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Combobox</h1>
      </header>

      <Section title="Searchable list">
        <div className="w-80">
          <Combobox
            options={OPTIONS}
            value={value}
            onValueChange={setValue}
            placeholder="Choose a client"
            searchPlaceholder="Search by name"
          />
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
